import { CloseCircleOutlined, EditOutlined, FundViewOutlined, SaveFilled } from '@ant-design/icons';
import { Button, Flex } from 'antd';
import { ColumnsType } from 'antd/es/table';
import { useAppDispatch } from 'app/hooks';
import { useColumnSearch } from 'app/useColumnSearch';
import { selectUser } from 'auth/states/userSlice';
import { setDrawer } from 'common/slices/drawerSlice';
import { formatAmount } from 'common/utils/common.utils';
import React from 'react';
import { useSelector } from 'react-redux';
import CreditLimitHistory from '../components/CreditLimitHistory';
import { ICreditLimitList } from '../type/CreditLimit.interface';

type Props = {
  isEditing: (record: ICreditLimitList) => boolean;
  editingKey: string;
  isLoading: boolean;
  save: (key: React.Key) => Promise<void>;
  cancel: () => void;
  edit: (record: Partial<ICreditLimitList>) => void;
};

type EditableColumnType<T> = ColumnsType<T>[number] & {
  editable?: boolean;
};

const CreditLimitColumn = ({
  isEditing,
  editingKey,
  isLoading,
  save,
  cancel,
  edit,
}: Props): EditableColumnType<ICreditLimitList & { key: React.Key }>[] => {
  const { getColumnSearchProps } = useColumnSearch<ICreditLimitList & { key: React.Key }>();
  const dispatch = useAppDispatch();
  const user = useSelector(selectUser);
  console.log(user, 'user');
  return [
    {
      title: 'Clients',
      dataIndex: 'client_name',
      key: 'client_name',

      filterSearch: true,
      ...getColumnSearchProps('client_name'),
    },

    {
      title: 'Client Type',
      dataIndex: 'client_type',
      key: 'client_type',

      filterSearch: true,
      ...getColumnSearchProps('client_type'),
    },
    {
      title: 'Assigned Personnel',
      dataIndex: 'contacted_person',
      key: 'contacted_person',

      filterSearch: true,
      ...getColumnSearchProps('contacted_person'),
    },
    // {
    //   title: 'Total Payment',
    //   dataIndex: 'client_invoice_total',
    //   key: 'client_invoice_total',
    //   align: 'right',
    //   render: (curr) => formatAmount(curr),
    // },
    {
      title: 'Outstanding Amount',
      dataIndex: 'client_last_balance',
      key: 'client_last_balance',
      align: 'right',
      render: (curr) => {
        const amount = Number(curr || 0);
        const color = amount > 0 ? 'green' : amount < 0 ? 'red' : undefined;

        return <span style={color ? { color } : undefined}>{formatAmount(amount)}</span>;
      },
    },

    {
      title: 'Approved Credit Limit',
      dataIndex: 'client_credit_limit',
      key: 'client_credit_limit',
      align: 'right',
      editable: true,
      render: (curr) => {
        const amount = Number(curr || 0);

        return amount ? formatAmount(amount) : '_';
      },
    },
    {
      title: 'Available Limit',
      dataIndex: 'remaining_credit',
      key: 'remaining_credit',
      align: 'right',
      render: (curr) => {
        const amount = curr !== null && curr !== undefined ? Number(curr) : null;
        return amount !== null ? formatAmount(amount) : '_';
      },
    },

    {
      title: 'Action',
      dataIndex: 'operation',
      render: (_: any, record: ICreditLimitList) => {
        const editable = isEditing(record);
        return editable ? (
          <Flex gap={5}>
            <Button
              type='primary'
              icon={<SaveFilled />}
              onClick={() => save(record.client_id)}
              size='small'
              loading={isLoading}
            />

            <Button
              onClick={() => cancel()}
              size='small'
              danger
              icon={<CloseCircleOutlined />}
              type='primary'
            />
          </Flex>
        ) : (
          <Flex gap={5}>
            <Button
              // disabled={editingKey !== ''}
              disabled={
                user?.user_agency_id === 76 && (user?.user_id === 948 || user?.user_id === 1661)
                  ? false
                  : true
              }
              onClick={() => edit(record)}
              size='small'
              type='primary'
              icon={<EditOutlined />}
            />
            <Button
              disabled={editingKey !== ''}
              onClick={() =>
                dispatch(
                  setDrawer({
                    open: true,
                    content: <CreditLimitHistory id={record.client_id} />,
                    title: 'Credit Limit History',
                    width: 500,
                  })
                )
              }
              size='small'
              type='primary'
              icon={<FundViewOutlined />}
            />
          </Flex>
        );
      },
    },
  ];
};

export default CreditLimitColumn;
